module.exports = require("npm:base64-js@1.3.1/index.js");